export function getCoachingTracks(state) {
    return state.coachingTracks;
}
export function activeCT(state) {
    return state.activeCT;
}
export function timelines(state) {
    return state.timelines;
}
export function timeline(state) {
    return state.timeline;
}
export function createPostDialog(state) {
    return state.createPostDialog;
}
export function editPostDialog(state) {
    return state.editPostDialog;
}
export function sharePostDialog(state) {
    return state.sharePostDialog;
}

export function getCoacheeActionItems(state) {
    return state.coacheeViewActionItems;
}

export function getCoachActionItems(state) {
    return state.coachViewActionItems;
}
